export var DEFAULT_REFERENCIAL = "abs"; // 'abs' || 'rel'
export var DEFAULT_TEMPORALITY = "YR"; // 'YR' || 'DC' || 'MO'
export var DEFAULT_CURRENT_DATE = new Date();
export var DEFAULT_CROP = 1; // Froment d'hiver;
export var DEFAULT_INDICATOR = "00RNYR_CURR";
export var DEFAULT_YEAR_MIN = 1991;
export var RS_DEFAULT_YEAR_MIN = 1999;
export var STATBEL_DEFAULT_YEAR_MIN = 1968;
export var STATBEL_SURF_DEFAULT_YEAR_MIN = 1980;
export var STATBEL_LAST_LOADED_YEAR = 2023;
export var SEL_CROPS = {
    name_fr: "Toutes",
    name_nl: "Alles",
    name_en: "All",
    name_de: "Alles",
};
export var SEL_METEO_SENSORS = {
    ALL: {
        name_fr: "-----",
        name_nl: "-----",
        name_en: "-----",
        name_de: "-----",
    },
    TE: {
        name_fr: "Températures",
        name_nl: "Temperatures",
        name_en: "Temperatures",
        name_de: "Temperatures",
    },
    RN: {
        name_fr: "Précipitations",
        name_nl: "Précipitations_nl",
        name_en: "Rainfalls",
        name_de: "Précipitations_de",
    },
    WD: {
        name_fr: "Evapotranspiration",
        name_nl: "Evapotranspiration",
        name_en: "Evapotranspiration",
        name_de: "Evapotranspiration",
    },
    RA: {
        name_fr: "Rayonnement solaire",
        name_nl: "Rayonnement_nl",
        name_en: "Solar radiation",
        name_de: "Rayonnement_de",
    },
};
export var SEL_TEMPORALITY = {
    YR: {
        name_fr: "Journalier",
        name_nl: "Dagelijk",
        name_en: "Daily",
        name_de: "Daily",
    },
    DC: {
        name_fr: "Décadaire",
        name_nl: "Decadal",
        name_en: "Decadal",
        name_de: "Decadal",
    },
    MO: {
        name_fr: "Mensuel",
        name_nl: "Maandelijk",
        name_en: "Monthly",
        name_de: "Monthly",
    },
};
/* from https://colorbrewer2.org/#type=sequential&scheme=PuBu&n=9*/
export var BLUES = [
    "#023858",
    "#045a8d",
    "#0570b0",
    "#3690c0",
    "#74a9cf",
    "#a6bddb",
    "#d0d1e6",
    "#ece7f2",
    "#fff7fb",
];
/* from https://colorbrewer2.org/#type=sequential&scheme=YlGn&n=9 */
export var GREENS = [
    "#004529",
    "#006837",
    "#238443",
    "#41ab5d",
    "#78c679",
    "#addd8e",
    "#d9f0a3",
    "#f7fcb9",
    "#ffffe5",
];
/* from https://colorbrewer2.org/#type=diverging&scheme=RdYlBu&n=11 */
export var RED2BLUE = [
    "#313695",
    "#4575b4",
    "#74add1",
    "#abd9e9",
    "#e0f3f8",
    "#ffffbf",
    "#fee090",
    "#fdae61",
    "#f46d43",
    "#d73027",
    "#a50026",
];
/* from https://colorbrewer2.org/#type=diverging&scheme=BrBG&n=11 */
export var BROWN2GREEN = [
    "#003c30",
    "#01665e",
    "#35978f",
    "#80cdc1",
    "#c7eae5",
    "#f5f5f5",
    "#f6e8c3",
    "#dfc27d",
    "#bf812d",
    "#8c510a",
    "#543005",
];
